<style lang="less">
    @import "../../global/font/iconfont.css";
    .asetDetail{
        border: 1px solid #d7dde4;
        background: #efefef;
        height: 100%;
        position: relative;
        .head{
            /*height: 46px;*/
            padding-top: 10px;
            border-bottom: 1px solid #d7dde4;
            margin-bottom: 20px;
            h1{
                display: inline;
                margin-left: 20px;
                color: #00c0ff;

                };
        }
        .layout-content{
            margin: 15px;
            overflow: hidden;
            background: #fff;
            border-radius: 4px;
            .main-content{
                padding-left:10px;
                .image-view {
                    text-align: center;
                    position: fixed;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    background-color: #000000;
                    z-index: 1000;
                img{
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: 100%;
                    }
                }
                .remark-img-part {
                .img-list {
                .img-item {
                    position: relative;
                    float: left;
                    margin-right: 9px;
                    margin-bottom: 9px;
                    width: 79px;
                    height: 79px;
                    background: no-repeat 50%;
                    background-size: cover;
                .icon-remove {2
                position: absolute;
                    right: 2px;
                    top: 2px;
                    padding: 0px 5px;
                    cursor: pointer;
                    border-radius: 50%;
                    background: #FF4949;
                    color: #fff;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -ms-flexbox;
                    display: none;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -ms-flex-align: center;
                    align-items: center;
                    justify-content: center;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                }
                }
                .img-item:hover{
                .icon-remove {
                    display:flex;
                }
                }
                }
                .uploader_input_wrp {
                    cursor: pointer;
                    float: left;
                    position: relative;
                    margin-right: 9px;
                    margin-bottom: 9px;
                    width: 79px;
                    height: 79px;
                    border: 1px solid #d9d9d9;
                }
                .uploader_input_wrp:before{
                    width: 2px;
                    height: 39.5px;
                }
                .uploader_input_wrp:after{
                    width: 39.5px;
                    height: 2px;
                }
                .uploader_input_wrp:before,.uploader_input_wrp:after {
                    content: " ";
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    -webkit-transform: translate(-50%,-50%);
                    transform: translate(-50%,-50%);
                    background-color: #d9d9d9;
                }
                }
                .footer{
                    text-align: center;
                }
                        }
                    }


    }

</style>
<template>
    <div class="asetDetail">
        <Row>
            <i-col span="24">
                <div class="layout-content">
                    <div class="head">
                        <h1 >{{updateTitle}}</h1>
                    </div>
                    <div class="main-content">
                        <div class="form-body">
                            <div>
                                <span>资产合同</span>
                                <div class="remark-img-part">
                                    <ul class="img-list">
                                        <li class="img-item" v-for="imgItem in assetsTable.contract_image" title="双击查看大图" :style="{'background-image':'url('+urlPrefix+imgItem+'?token='+token+')'}" @dblclick="handleView(true,imgItem)">
                                        </li>
                                    </ul>
                                    <Button type="primary"  style="width: 100px;margin-left: 50px;" @click="download_img('contract')">一键下载</Button>
                                    <div  style="height: 93px;"></div>
                                </div>
                            </div>
                            <div>
                                <span>资产发票</span>
                                <div class="remark-img-part">
                                    <ul class="img-list">
                                        <li class="img-item" v-for="imgItem in assetsTable.invoice_image" title="双击查看大图" :style="{'background-image':'url('+urlPrefix+imgItem+'?token='+token+')'}" @dblclick="handleView(true,imgItem)">
                                        </li>
                                    </ul>
                                    <Button type="primary"  style="width: 100px;margin-left: 50px;" @click="download_img('invoice')">一键下载</Button>
                                    <div  style="height: 93px;"></div>
                                </div>
                            </div>
                            <div>
                                <span>资产图片</span>
                                <div class="remark-img-part">
                                    <ul class="img-list">
                                        <li class="img-item" v-for="imgItem in assetsTable.asset_image" title="双击查看大图" :style="{'background-image':'url('+urlPrefix+imgItem+'?token='+token+')'}" @dblclick="handleView(true,imgItem)">
                                        </li>
                                    </ul>
                                    <Button type="primary"  style="width: 100px;margin-left: 50px;" @click="download_img('asset')">一键下载</Button>
                                    <div  style="height: 93px;"></div>
                                </div>
                            </div>
                            <div>
                                <span class="ivu-form-item-label" style="font-size: 14px;">行政事业系统卡片编号</span>
                                <div>
                                    <p style="margin-top: 20px;display: inline-block">{{assetsTable.admin_doc.filename}}</p>
                                    <Button type="primary"  style="width: 100px;margin-left: 50px;" @click="download_asets('admin')">下载</Button>
                                </div>

                            </div>
                            <div style="margin-top: 40px;margin-bottom: 40px;">
                                <span class="ivu-form-item-label" style="font-size: 14px;">用友系统卡片编号</span>
                                <div>
                                    <p style="margin-top: 20px;display: inline-block">{{assetsTable.yonyou_doc.filename}}</p>
                                    <Button type="primary"  style="width: 100px;margin-left: 50px;" @click="download_asets('yongyou')">下载</Button>
                                </div>

                            </div>
                            <div style="margin-top: 40px;margin-bottom: 40px;">
                                <span class="ivu-form-item-label" style="font-size: 14px;">固定资产验收单</span>
                                <Button type="primary"  style="width: 100px;margin-left: 50px;" @click="download_asets('guding')">下载</Button>
                            </div>
                            <Form ref="assetsForm" :model="assetsTable" label-position="top" inline>
                                <div>
                                    <FormItem label="资产信息描述" style="width: 90%;" >
                                        <Input type="textarea" v-model="assetsTable.remarks" style="max-width: 100%;width: 100%" :autosize="{minRows: 2,maxRows: 5}"></Input>
                                    </FormItem>
                                </div>
                                <FormItem label="固定资产名称" prop="name" >
                                    <Input  v-model="assetsTable.name"></Input>
                                </FormItem>
                                <FormItem label="用友系统卡片编号"  >
                                    <Input  v-model="assetsTable.yonyou_id"></Input>
                                </FormItem>
                                <FormItem label="行政事业系统编号"  >
                                    <Input  v-model="assetsTable.admin_id"></Input>
                                </FormItem>
                                <FormItem label="规格型号"  >
                                    <Input  v-model="assetsTable.model"></Input>
                                </FormItem>
                                <FormItem label="资产分类代码"  >
                                    <Input  v-model="assetsTable.class_code"></Input>
                                </FormItem>
                                <FormItem label="资产所属部门" prop="department" >
                                    <!--<Input  v-model="assetsTable.department"></Input>-->
                                    <Select v-model="assetsTable.department" clearable style="width:162px;display: inline-block">
                                        <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem label="资产原值"  >
                                    <Input  v-model="assetsTable.full_price"></Input>
                                </FormItem>
                                <FormItem label="累计折旧"  >
                                    <Input  v-model="assetsTable.depreciation"></Input>
                                </FormItem>
                                <FormItem label="净值"  >
                                    <Input  v-model="assetsTable.net_value"></Input>
                                </FormItem>
                                <FormItem label="资产数量" prop="count" >
                                    <Input  v-model="assetsTable.count"></Input>
                                </FormItem>
                                <FormItem label="计量单位"  >
                                    <Input  v-model="assetsTable.unit"></Input>
                                </FormItem>
                                <FormItem label="增加方式"  >
                                    <Input  v-model="assetsTable.add_type"></Input>
                                </FormItem>
                                <FormItem label="增加日期"  prop="add_date">
                                    <!--<Input  v-model="assetsTable.add_date"></Input>-->
                                    <DatePicker type="date" v-model="assetsTable.add_date" style="width: 168px"></DatePicker>
                                </FormItem>
                                <FormItem label="入账日期"  >
                                    <!--<Input  v-model="assetsTable.entry_date"></Input>-->
                                    <DatePicker type="date" v-model="assetsTable.entry_date" style="width: 168px"></DatePicker>
                                </FormItem>
                                <FormItem label="入账形式"  >
                                    <Input  v-model="assetsTable.entry_type"></Input>
                                </FormItem>
                                <FormItem label="会计凭证号"  >
                                    <Input  v-model="assetsTable.accounting_id"></Input>
                                </FormItem>
                                <FormItem label="建筑面积"  >
                                    <Input  v-model="assetsTable.build_area"></Input>
                                </FormItem>
                                <FormItem label="车牌号"  >
                                    <Input  v-model="assetsTable.plate_number"></Input>
                                </FormItem>
                                <FormItem label="资金来源"  >
                                    <Input  v-model="assetsTable.fund_source"></Input>
                                </FormItem>
                                <FormItem label="项目名称"  >
                                    <Input  v-model="assetsTable.project_name"></Input>
                                </FormItem>
                                <FormItem label="发票编号"  >
                                    <Input  v-model="assetsTable.invoice_number"></Input>
                                </FormItem>
                                <FormItem label="实物保管人"  >
                                    <Input  v-model="assetsTable.keeper"></Input>
                                </FormItem>
                                <FormItem label="所属单位"  >
                                    <Input  v-model="assetsTable.company"></Input>
                                </FormItem>
                                <FormItem label="使用状况"  >
                                    <Input  v-model="assetsTable.use_state"></Input>
                                </FormItem>
                                <FormItem label="资产存放地点" prop="location" >
                                    <Input  v-model="assetsTable.location"></Input>
                                </FormItem>
                                <FormItem label="使用年限"  >
                                    <Input  v-model="assetsTable.use_year"></Input>
                                </FormItem>
                                <FormItem label="财务负责人"  >
                                    <Input  v-model="assetsTable.finance_person"></Input>
                                </FormItem>
                                <FormItem label="销账日期">
                                    <DatePicker type="date" format="yyyy-MM-dd" @on-change="cancel_date($event,'cancel')"  v-model="assetsTable.cancel_date"  style="width: 168px"></DatePicker>
                                </FormItem>
                                <FormItem label="注销人">
                                    <Input  v-model="assetsTable.cancel_person"></Input>
                                </FormItem>
                                <FormItem label="减少方式">
                                    <Input  v-model="assetsTable.cut_type"></Input>
                                </FormItem>
                                <FormItem label="变动日期">
                                    <DatePicker type="date" format="yyyy-MM-dd" @on-change="cancel_date($event,'change_date')" v-model="assetsTable.change_date" style="width: 168px"></DatePicker>
                                </FormItem>
                                <FormItem label="变动后使用部门">
                                    <Input  v-model="assetsTable.change_dep"></Input>
                                </FormItem>
                                <FormItem label="使用面积">
                                    <Input  v-model="assetsTable.square"></Input>
                                </FormItem>
                                <FormItem label="供应商">
                                    <Input  v-model="assetsTable.supplier"></Input>
                                </FormItem>
                                <FormItem label="生产厂家">
                                    <Input  v-model="assetsTable.manufacturer"></Input>
                                </FormItem>


                            </Form>

                        </div>
                        <div class="footer">
                            <Button @click="cancel" style="margin-left: 30px;">返回</Button>
                        </div>
                    </div>
                    <div class="image-view" v-show="imageViewVisible" @dblclick="handleView(false)">
                        <img :src="urlPrefix+viewPath+'?token='+token" alt="" title="双击关闭大图">
                    </div>
                </div>
            </i-col>

        </Row>
    </div>

</template>

<script>
    import {deepCopy} from 'iview/src/utils/assist';
    export default {
        data () {
            return {
                contractUploadUrl:parameters.domain+'/sys/assetlist/uploadcontract',
                billUploadUrl:parameters.domain+'/sys/assetlist/uploadinvoice',
                assetUploadUrl:parameters.domain+'/sys/assetlist/uploadasset',
                adminUploadUrl:parameters.domain+'/sys/assetlist/uploadadmin',
                yongyouUploadUrl:parameters.domain+'/sys/assetlist/uploadyonyou',
                assetdocUploadUrl:parameters.domain+'/sys/assetlist/uploadassetdoc',
                urlPrefix:parameters.domain,
                token:this.getKey('token'),
                updateTitle:'',
                viewPath:'',
                username:'',
                startDate:'',
                endDate:'',
                ql_name:'',
                ql_department:'',
                ql_lend_department:'',
                error_msg:'',
                asets_doc:'',
                imageViewVisible:false,
                columnFieldsModalShow:false,
                check_yonyou_msg:false,
                check_hangye_msg:false,
                asetsTable:false,
                modal3:false,
                isScrap:true,
                show_bill:false,
                formInline:{},
                upData_yongyou:{},
                upData_hangye:{},
                cover_msg:{},
                currentUploadFileList:[],
                departmentList:[],
                uploadArr:[],
                assetsTable:{
                    name:'',
                    yonyou_id:'',
                    admin_id:'',
                    model:'',
                    class_code:'',
                    department:'',
                    full_price:'',
                    depreciation:'',
                    net_value:'',
                    count:'',
                    unit:'',
                    add_type:'',
                    add_date:'',
                    entry_date:'',
                    accounting_id:'',
                    build_area:'',
                    plate_number:'',
                    fund_source:'',
                    project_name:'',
                    invoice_number:'',
                    keeper:'',
                    remarks:'',
                    admin_doc:{filename:'',path:''},
//                    asset_doc:'',
                    yonyou_doc:{filename:'',path:''},
                    manufacturer:'',
                    supplier:'',
                    square:'',
                    change_dep:'',
                    change_date:'',
                    cut_type:'',
                    cancel_person:'',
                    cancel_date:'',
                    finance_person:'',
                    use_year:'',
                    location:'',
                    usr_state:'',
                    company:'',
                    entry_type:'',
                    invoice_image:[],
                    contract_image:[],
                    asset_image:[],
                }
            }

        },
        methods: {
            //部门列表
            getDepartment:function () {
                var that = this;
                var params = {};
                params.data = {};
                params.token = this.getKey('token');
                params.url = '/sys/department/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.departmentList = res.data.result.result;
//                    that.recordPage.total = res.result.totalSize
//                    that.dataSourceList.reverse()

                }
                this.ajaxPost(params);
            },
            cancel_date:function (data,type) {
                console.log(data);
                console.log(type);
                var that=this;
                switch (type){
                    case 'cancel':
                        that.assetsTable.cancel_date=data
                        console.log(that.assetsTable.cancel_date);
                        break;
                    case 'change_date':
                        that.assetsTable.change_date=data
                        console.log(that.assetsTable.change_date);
                        break;
                }

            },
            download_img:function (type) {
                let that = this;
                let params = {};
                params.url = "/manage/messagelist/download";
                params.token = window.localStorage.getItem("token");
                if(type=='contract'){
                    for(let i=0;i<that.assetsTable.contract_image.length;i++) {
                        params.data = {
                            "path": that.assetsTable.contract_image[i]
                        };
                        params.success = function (res) {
                            var blob = new Blob([res.data], {type: "application/octet-stream"}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                            var downloadElement = document.createElement('a');
                            var href = window.URL.createObjectURL(blob); //创建下载的链接
                            downloadElement.href = href;
                            downloadElement.download = '资产合同.jpg'; //下载后文件名
                            document.body.appendChild(downloadElement);
                            downloadElement.click(); //点击下载
                            document.body.removeChild(downloadElement); //下载完成移除元素
                            window.URL.revokeObjectURL(href); //释放掉blob对象
                        }
                        that.ajaxGet(params);
                    }

                }else if(type=='invoice'){
                    for(let i=0;i<that.assetsTable.invoice_image.length;i++) {
                        params.data = {
                            "path": that.assetsTable.invoice_image[i]
                        };
                        params.success = function (res) {
                            console.log(res);
                            var blob = new Blob([res.data], {type: "application/octet-stream"}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                            var downloadElement = document.createElement('a');
                            var href = window.URL.createObjectURL(blob); //创建下载的链接
                            downloadElement.href = href;
                            downloadElement.download = '资产发票.jpg'; //下载后文件名
                            document.body.appendChild(downloadElement);
                            downloadElement.click(); //点击下载
                            document.body.removeChild(downloadElement); //下载完成移除元素
                            window.URL.revokeObjectURL(href); //释放掉blob对象
                        }
                        that.ajaxGet(params);
                    }
                }else if(type=='asset'){
                    for(let i=0;i<that.assetsTable.asset_image.length;i++) {
                        params.data = {
                            "path": that.assetsTable.asset_image[i]
                        };
                        params.success = function (res) {
                            console.log(res);
                            var blob = new Blob([res.data], {type: "application/octet-stream"}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                            var downloadElement = document.createElement('a');
                            var href = window.URL.createObjectURL(blob); //创建下载的链接
                            downloadElement.href = href;
                            downloadElement.download = '资产图片.jpg'; //下载后文件名
                            document.body.appendChild(downloadElement);
                            downloadElement.click(); //点击下载
                            document.body.removeChild(downloadElement); //下载完成移除元素
                            window.URL.revokeObjectURL(href); //释放掉blob对象
                        }
                        that.ajaxGet(params);
                    }
                }

            },
            //下载固定资产验收单
            download_asets:function (type) {
                let that = this;
                let params = {};
                params.url = "/manage/messagelist/download";
                params.token = window.localStorage.getItem("token");
                if(type=='guding'){
                    params.data = {
                        "path" : that.assetsTable.asset_doc
                    };
                }else if(type=='yongyou'){
                    params.data = {
                        "path" : that.assetsTable.yonyou_doc.path
                    };
                }else if(type=='admin'){
                    params.data = {
                        "path" : that.assetsTable.admin_doc.path
                    };
                }
                params.success=function(res){
                    var blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                    var downloadElement = document.createElement('a');
                    var href = window.URL.createObjectURL(blob); //创建下载的链接
                    downloadElement.href = href;
                    if(type=='guding'){
                        downloadElement.download = '固定资产验收单' //下载后文件名
                    }else if(type=='yongyou'){
                        downloadElement.download = '用友系统卡片编号' //下载后文件名
                    }else if(type=='admin'){
                        downloadElement.download = '行政事业系统卡片编号' //下载后文件名
                    }
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement); //下载完成移除元素
                    window.URL.revokeObjectURL(href); //释放掉blob对象
                }



                that.ajaxGet(params);

            },

            //查看大图
            handleView:function (visible,imagePath) {
                this.imageViewVisible = visible;
                this.viewPath = imagePath;
            },
            cancel:function () {
                this.$router.push('asetsList')
            },
            getParams:function () {
                // 取到路由带过来的参数
                let routerParams = this.$route.params
                console.log(routerParams);
                this.updateTitle='资产信息详情';
                this.assetsTable=routerParams;
//                if(JSON.stringify(routerParams)=='{}'){
//                    this.updateTitle='资产信息提取';
//                }else{
//                    this.updateTitle='资产信息修改';
//                    this.assetsTable=routerParams;
//                    this.show_bill=true
//                    if(this.assetsTable.state=='已报废'||this.assetsTable.state=='待报废'){
//                        this.isScrap=false;
//                    }
//                    console.log(this.assetsTable);
//                }
                // 将数据放在当前组件的数据内

            }
        },
        mounted: function () {
            this.getParams()
            this.getDepartment()
            console.log(this.assetsTable.asset_doc);


        },
        watch: {
            // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
            '$route': 'getParams'
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/propertyMana/asetDetail.vue